import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="employer-settings-tabs"
export default class extends Controller {
  static targets = [
    'btn',
    'tab',
    'select',
  ]

  declare readonly btnTargets: HTMLElement[]
  declare readonly tabTargets: HTMLElement[]
  declare readonly selectTarget: HTMLSelectElement

  static values = {
    activeClasses: String,
    inactiveClasses: String,
    defaultTab: String,
  }

  declare defaultTabValue: string
  declare activeClassesValue: string
  declare inactiveClassesValue: string

  connect () {
    const params = new URLSearchParams(window.location.search)
    const tabId = params.get('tab')
    let tabBtn: HTMLElement

    if (tabId) {
      tabBtn = this.btnTargets.find(element => element.dataset.tabId === tabId) as HTMLElement
      this.showTab(tabId, tabBtn)
    } else {
      tabBtn = this.btnTargets.find(element => element.dataset.tabId === this.defaultTabValue) as HTMLElement
      this.showTab(this.defaultTabValue, tabBtn)
    }
  }

  select (event: Event) {
    const target = event.currentTarget as HTMLElement
    let tabId: string

    if (target.tagName === 'SELECT') {
      const selectElement = target as HTMLSelectElement
      const selectedOption = selectElement.options[selectElement.selectedIndex] as HTMLOptionElement
      tabId = selectedOption.dataset.tabId as string
    } else {
      tabId = target.dataset.tabId as string
    }

    this.showTab(tabId, target)

    const params = new URLSearchParams(window.location.search)
    params.set('tab', tabId)
    params.delete('success')
    window.history.pushState({}, '', `${window.location.pathname}?${params}`)
  }

  showTab (tabId: string, tabBtn: HTMLElement) {
    const selectedTab = this.tabTargets.find(element => element.id === tabId)

    if (selectedTab && selectedTab.hidden) {
      // eslint-disable-next-line no-return-assign
      this.tabTargets.forEach(tab => tab.hidden = true)
      selectedTab.hidden = false
    }

    // Set the CSS on the tab navigation buttons
    this.btnTargets.forEach(btn => btn.classList.remove(...this.activeClassesValue.split(' ')))
    this.btnTargets.forEach(btn => btn.classList.add('border-transparent', 'text-gray-500'))
    tabBtn.classList.add(...this.activeClassesValue.split(' '))
    tabBtn.classList.remove('border-transparent')

    // Set the correct select option on the mobile dropdown
    const option = Array.from(this.selectTarget.options).findIndex(opt => opt.dataset.tabId === tabId)
    this.selectTarget.selectedIndex = option
  }
}
